/**
 * Адрес общего каталога Platform списком (`CatalogProductsController`, UI-SECTIONS).
 * Литерал `/api/` законен только в файлах `api/urls.ts` (eslint).
 */
export const PLATFORM_COMMON_CATALOG_URLS = {
  products: '/api/platform/v1/catalog/products',
} as const
